export enum WorkConfigEnum {

  BOOK = 'book',
  MAGAZINE = 'magazine',
  ARTICLE = 'article',
  MAP = 'map',
  IMAGE = 'image',
  FOTO = 'foto',
  ADWERT = 'adwert',
  POSTER = 'poster',
  MANUSCRIPT = 'manuscript',


}
